import { FACEBOOK_URL, TIKTOK_URL } from "@/data/site";

const ICONS = {
  facebook: (
    <path d="M14 8.5h2V5.5h-2c-2 0-3.5 1.5-3.5 3.6V11H8v3h2.5v7h3v-7H16l.5-3h-3V9.3c0-.5.4-.8.9-.8Z" />
  ),
  tiktok: (
    <path d="M16.5 3c.4 2 1.7 3.4 3.5 3.6v2.7c-1.3 0-2.5-.4-3.5-1v5.8a5.8 5.8 0 1 1-5.8-5.8c.3 0 .6 0 .9.1v2.9a2.9 2.9 0 1 0 2 2.8V3h2.9Z" />
  ),
};

const LINKS = [
  { key: "facebook", label: "Facebook", href: FACEBOOK_URL },
  { key: "tiktok", label: "TikTok", href: TIKTOK_URL },
];

export default function SocialIcons({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="social-icons">
      {LINKS.map((l) => (
        <a
          key={l.key}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${l.label} — Authentically Yours (opens in a new tab)`}
          className="inline-flex h-10 w-10 items-center justify-center border border-white/25 text-white hover:border-blush hover:text-blush transition-colors"
          data-testid={`social-${l.key}`}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            {ICONS[l.key]}
          </svg>
        </a>
      ))}
    </div>
  );
}
